import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';


@Component({
  selector: 'app-standing-creation',
  templateUrl: './standing-creation.component.html',
  styleUrls: ['./standing-creation.component.scss']
})
export class StandingCreationComponent implements OnInit {
  selectedCourts: string[] = []; 
  startDate = moment().format('YYYY-MM-DD');
  endDate = moment().endOf('month').format('YYYY-MM-DD');
  noOfMinutesPerMatch="20"
  public startTime: Date = new Date();
  public endTime: Date = new Date();
  showKnockoutSettings: boolean = true;


  public startTimeChanged(): void {
    console.log('Time changed to: ' + this.startTime);
  }

  public endTimeChanged(): void {
    console.log('Time changed to: ' + this.endTime);
  }


  public isLoading: boolean = false;
  selectedCategory={categoryName: "Category A", categoryCode: "A"}
  selectedCategory1={categoryName: "Category A", categoryCode: "A"}
  noOfTeamsAvailable=26
  isGenerateTiming=true

  categoryList=[  
    {categoryName: "Category A", categoryCode: "A"},
    {categoryName: "Category B", categoryCode: "B"},
    // {categoryName: "Category C", categoryCode: "C"},
    // {categoryName: "Category W", categoryCode: "W"}
  ]

  coursList=[]
  selectedTournament= "singleElimination"

  tournamentList=[  
    {tournamentName: "Single Elimination", tournamentCode: "singleElimination"},
    {tournamentName: "Round Robin", tournamentCode: "roundRobin"},
  ]
  standingDetails:FormGroup
  timingDetails:FormGroup
  teamGroups?
  groupsNames?
  selectedGroups: string[] = [];


//   mainObject:any={"A":{
//     "selectedCategoryCode": "A",
//     "groupsWithTeams": [
//         {
//             "name": "A",
//             "teams": [
//                 "Team 1",
//                 "Team 2"
//             ]
//         },
//         {
//             "name": "B",
//             "teams": [
//                 "Team 3",
//                 "Team 4",
//                 "Team 5",
//                 "Team 6",
//                 "Team 7",
//                 "Team 8",
//                 "Team 9",
//                 "Team 10",
//                 "Team 11",
//                 "Team 12",
//                 "Team 13",
//                 "Team 14",
//                 "Team 15",
//                 "Team 16",
//                 "Team 17",
//                 "Team 18",
//                 "Team 19",
//                 "Team 20",
//                 "Team 21",
//                 "Team 22",
//                 "Team 23",
//                 "Team 24",
//                 "Team 25",
//                 "Team 26"
//             ]
//         }
//     ],
//     "selectedTournament": "singleElimination",
//     "noOfGroups": "2",
//     "noOfTeamPerGroups": "2"
// }}

// mainObject:any={}
mainObject:any={
  "A": {
      "selectedCategoryCode": "A",
      "groupsWithTeams": [
          {
              "name": "A",
              "teams": [
                  "Team 1",
                  "Team 2",
                  "Team 3",
                  "Team 4",
                  "Team 5"
              ]
          },
          {
              "name": "B",
              "teams": [
                  "Team 6",
                  "Team 7",
                  "Team 8",
                  "Team 9",
                  "Team 10"
              ]
          },
          {
              "name": "C",
              "teams": [
                  "Team 11",
                  "Team 12",
                  "Team 13",
                  "Team 14",
                  "Team 15"
              ]
          },
          {
              "name": "D",
              "teams": [
                  "Team 16",
                  "Team 17",
                  "Team 18",
                  "Team 19",
                  "Team 20"
              ]
          },
          {
              "name": "E",
              "teams": [
                  "Team 21",
                  "Team 22",
                  "Team 23",
                  "Team 24",
                  "Team 25",
                  "Team 26"
              ]
          }
      ],
      "selectedTournament": "singleElimination",
      "noOfGroups": "5",
      "noOfTeamPerGroups": "5",
      "selectedCourts": [
          "Rajhi Court",
          "Court 2",
          "Court 3 "
      ],
      "selectedGroups": [
          "A",
          "B",
          "C",
          "E"
      ],
      "startDate": "2024-01-05",
      "endDate": "2024-01-31",
      "startTime": "2024-01-05T18:23:56.654Z",
      "endTime": "2024-01-05T18:23:56.654Z",
      "noOfMinutesPerMatch": "20"
  },
  "B": {
      "selectedCategoryCode": "B",
      "groupsWithTeams": [
          {
              "name": "A",
              "teams": [
                  "Team 1",
                  "Team 2",
                  "Team 3",
                  "Team 4",
                  "Team 5"
              ]
          },
          {
              "name": "B",
              "teams": [
                  "Team 6",
                  "Team 7",
                  "Team 8",
                  "Team 9",
                  "Team 10"
              ]
          },
          {
              "name": "C",
              "teams": [
                  "Team 11",
                  "Team 12",
                  "Team 13",
                  "Team 14",
                  "Team 15"
              ]
          },
          {
              "name": "D",
              "teams": [
                  "Team 16",
                  "Team 17",
                  "Team 18",
                  "Team 19",
                  "Team 20"
              ]
          },
          {
              "name": "E",
              "teams": [
                  "Team 21",
                  "Team 22",
                  "Team 23",
                  "Team 24",
                  "Team 25",
                  "Team 26"
              ]
          }
      ],
      "selectedTournament": "singleElimination",
      "noOfGroups": "5",
      "noOfTeamPerGroups": "5",
      "selectedCourts": [
          "Rajhi Court",
          "Court 2"
      ],
      "selectedGroups": [
          "A",
          "B"
      ],
      "startDate": "2024-01-05",
      "endDate": "2024-01-31",
      "startTime": "2024-01-05T18:23:56.654Z",
      "endTime": "2024-01-05T18:23:56.654Z",
      "noOfMinutesPerMatch": "20"
  }
}


  @ViewChild(ToastComp) toastComp: ToastComp;
  
  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    ) {
      
    this.toastr.toastrConfig.preventDuplicates = true;
    this.coursList = this.storageSrv.getCourtsGlobal();

  }

  onCategoryChange = async (event: any) => {
    const selectedCategory=this.categoryList.find(c=>c.categoryCode ===event.target.value)
    this.selectedCategory = selectedCategory; 
    if(this.mainObject[selectedCategory.categoryCode]){
      this.teamGroups=this.mainObject[selectedCategory.categoryCode].groupsWithTeams
      this.selectedTournament=this.mainObject[selectedCategory.categoryCode].selectedTournament
      this.groupsNames=this.mainObject[selectedCategory.categoryCode].groupsWithTeams.map(group=>group.name)

      // this.standingDetails.value.noOfGroups=this.mainObject[selectedCategory.categoryCode].noOfGroups
      // this.standingDetails.value.noOfTeamPerGroups=this.mainObject[selectedCategory.categoryCode].noOfTeamPerGroups

      this.standingDetails.get('noOfTeamPerGroups').setValue(this.mainObject[selectedCategory.categoryCode].noOfTeamPerGroups);
      this.standingDetails.get('noOfGroups').setValue(this.mainObject[selectedCategory.categoryCode].noOfGroups);
      this.toastr.success(`Already Setting Saved`, );

}
else{
  this.resetValue()

}

  };

  onTournamentChange = async (event: any) => {
    const selectedTournament=this.tournamentList.find(c=>c.tournamentCode ===event.target.value)
    this.selectedTournament = selectedTournament.tournamentCode; 
  };


  ngOnInit(): void {
    this.createForm();
   
  }

  createForm(): void {
    this.standingDetails = this.fb.group({
      noOfGroups: ["", [Validators.required, Validators.pattern(/^\d+$/),Validators.min(1),Validators.max(this.noOfTeamsAvailable)]],
      noOfTeamPerGroups: ["",[Validators.required, Validators.pattern(/^\d+$/),Validators.min(1),Validators.max(this.noOfTeamsAvailable)]],      
    });

    this.timingDetails= this.fb.group({
      noOfMinutesPerMatch: ['6', [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfTeamPerGroups: ['5',[Validators.required, Validators.pattern(/^\d+$/)]], 
      startDate: ['5',[Validators.required, Validators.pattern(/^\d+$/)]],
      endDate:['5',[Validators.required, Validators.pattern(/^\d+$/)]],

    });
  }
  
  deletePhone($event):void{
    this.isGenerateTiming=true
    console.log('event',$event);
  }

  saveSettingBasedOnCategory($event):void{

    this.mainObject[this.selectedCategory.categoryCode]={
      selectedCategoryCode:this.selectedCategory.categoryCode,
      groupsWithTeams:$event.updatedTeams,
      selectedTournament:this.selectedTournament,
      noOfGroups:this.standingDetails.value.noOfGroups,
      noOfTeamPerGroups:this.standingDetails.value.noOfTeamPerGroups
    }

    console.log('Main',this.mainObject);
    this.toastr.success(`Setting Saved`, );
  
  }

  resetValue=()=>{
    this.teamGroups=[]
    this.groupsNames=[]
    this.standingDetails.get('noOfTeamPerGroups').setValue(0);
    this.standingDetails.get('noOfGroups').setValue(0);
    // this.selectedTournament="roundRobin"

  }

  onSubmit(): void {

    if (this.standingDetails.valid) {
      console.log(this.standingDetails);
      this.createTeamGroups(this.noOfTeamsAvailable,this.standingDetails.value.noOfGroups,this.standingDetails.value.noOfTeamPerGroups)

    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.standingDetails);
    }
  }

  
  markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
  
  createTeamGroups(totalTeams, noOfGroups, teamsPerGroup) {
    const teamGroups = [];
    const groupsNames = [];
    const temp =  (teamsPerGroup*noOfGroups);
    const teamsInLastGroup = totalTeams-temp;
    for (let i = 0; i < noOfGroups; i++) {
      const groupName = String.fromCharCode(65 + i); // A, B, C, ...
      const group = { name: `${groupName}`, teams: [] };
  
      for (let j = 0; j < teamsPerGroup&&i * teamsPerGroup + j+1<=totalTeams; j++) {
        const teamIndex = i * teamsPerGroup + j;
        group.teams.push(`Team ${teamIndex + 1}`);
      }
      if(group.teams.length<=0){
        this.toastr.warning(`No more teams available for Groups`, );
        break
      }
  
      groupsNames.push(groupName);
      teamGroups.push(group);
    }
  
    if (teamsInLastGroup > 0) {
      const lastGroup = teamGroups[teamGroups.length - 1];
      const startIndex = teamGroups.length * teamsPerGroup; 
      for (let i = 0; i < teamsInLastGroup; i++) {
        const teamIndex = startIndex + i;
        lastGroup?.teams?.push(`Team ${teamIndex + 1}`);
      }
      this.toastr.warning(`Last group has ${lastGroup.teams.length} members.`, );
    }
  
    this.teamGroups = teamGroups;
    this.groupsNames = groupsNames;
    console.log('teamGroups', teamGroups);
  }
  
  onCategoryChange1 = async (event: any) => {
    const selectedCategory1=this.categoryList.find(c=>c.categoryCode ===event.target.value)
    this.selectedCategory1 = selectedCategory1;
    if(!this.mainObject[this.selectedCategory1.categoryCode]) 
      this.toastr.error('Save Groups Setting for this Category first')
      this.selectedCourts=[]
      this.selectedGroups=[]
};

  getListOfGroups=() => {
    let groups=this.mainObject[this.selectedCategory1.categoryCode]?.groupsWithTeams?.map(element=>element.name)
    return  groups  
  }

dataNotAvailable=()=>{
 if(this.mainObject[this.selectedCategory1.categoryCode])
    return false
  return true
}

isTimingSaved=()=>{
  if(this.mainObject[this.selectedCategory1.categoryCode]?.selectedCourts?.length>0)
  return true
return false
}

saveTimingSetting=()=>{
  this.mainObject[this.selectedCategory1.categoryCode]={
    ...this.mainObject[this.selectedCategory1.categoryCode],
    selectedCourts:this.selectedCourts,
    selectedGroups:this.selectedGroups,
    startDate:this.startDate,
    endDate:this.endDate,
    startTime:this.startTime,
    endTime:this.endTime,
    noOfMinutesPerMatch:this.noOfMinutesPerMatch


  }

  this.toastr.success("Timing Saved for this category")
}

handleCheckboxChange(courtName: string) {
  const index = this.selectedCourts.indexOf(courtName);

  if (index === -1) {
    // If not found, add to the array
    this.selectedCourts.push(courtName);
  } else {
    // If found, remove from the array
    this.selectedCourts.splice(index, 1);
  }

  // Log or use this.selectedCourts as needed
  console.log('Selected Courts:', this.selectedCourts);
}

handleGroupCheckboxChange(groupName: string) {
  const index = this.selectedGroups.indexOf(groupName);

  if (index === -1) {
    // If not found, add to the array
    this.selectedGroups.push(groupName);
  } else {
    // If found, remove from the array
    this.selectedGroups.splice(index, 1);
  }

  // Log or use this.selectedGroups as needed
  console.log('Selected groups:', this.selectedGroups );
}

isTimingSavedForAllCategories=()=>{
  for(let category of this.categoryList){
    if(this.mainObject[category.categoryCode]?.selectedCourts?.length>0)
    continue
  else
  return false;
  }
  return true;

}

saveAllTimingSetting=()=>{
  console.log('teamGroups',this.teamGroups);
  console.log(this.mainObject)
}


}
